<template>
  <div class="rc-router-link">
    <div v-for="(item, index) in data" :key="item.prop || index" class="rc-router-link-item">
      <router-link v-bind="item"  @click="handleClick(item, index, data)">
        <slot v-bind="item" :data="data">{{item.label}}</slot>
      </router-link>
      <slot :name="item.prop"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "RcRouterLink",
  props: {
    data: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    handleClick(item, index, data) {
      this.$emit("link", { item, index, data });
    }
  }
};
</script>
